/**
 * DEV-2684 Model Y — /ben (kullanıcı özeti) tazeleme yardımcısı.
 *
 * Yetki bir yöneticinin ekranında değiştiğinde (rol atama, izin güncelleme) ya da
 * sunucu 403 döndürdüğünde istemcideki `store.state.user.yetki` bayat kalır; menü ve
 * buton görünürlüğü yanlış olur. Bu yardımcı /ben'i yeniden çekip `setUser` ile günceller.
 *
 * İki koruma:
 *  - Aralık sınırı (≥30 sn): art arda gelen 403'ler veya bildirim döngüleri /ben'i
 *    dövemez. `force: true` (ör. "İzinler Güncellendi" bildirimi) bu sınırı atlar.
 *  - Tek uçuş (reentrancy): aynı anda ikinci bir tazeleme başlamaz. Uçuşta gelen `force` düşmez:
 *    uçuştaki istek değişiklikten önce gitmiş olabilir; o bitince bir kez daha çekilir (bekleyenler birleşir).
 *
 * NOT: /ben isteğinin KENDİSİ 403 dönerse tazeleme yine /ben ister → sonsuz döngü.
 * Bu durum çağıran tarafta (StatusCodeHelper 403 dalı) istek URL'si kontrol edilerek
 * önlenir; buradaki aralık sınırı da ek güvenliktir.
 */
// @/store modül düzeyinde import edilmez: StatusCodeHelper bu modülü yükler ve store'u (socket
// eklentisi dahil) her çağırana taşırdı. Store, kök örnekten çağrı anında okunur.
import app from "@/main";
import {benIstegiBaslat, benYanitiYazilsinMi} from "@/utils/benIstegi";

const MIN_ARALIK_MS = 30000;
let sonTazelemeZamani = 0;
let ucustaki: Promise<boolean> | null = null;
let siradakiZorla: Promise<boolean> | null = null;

export interface BenTazeleSecenek {
    /** Aralık sınırını atla (yetki değiştiği kesin olduğunda). */
    force?: boolean;
}

/**
 * /ben'i çekip store'daki kullanıcıyı günceller.
 * @returns tazeleme yapıldıysa true, atlandıysa/başarısızsa false. Uçuşta gelen `force` çağrısı
 * sıradaki (uçuştakinden sonraki) tazelemenin sonucunu alır.
 */
export function benTazele(secenek: BenTazeleSecenek = {}): Promise<boolean> {
    if (secenek.force) {
        if (siradakiZorla) {
            return siradakiZorla;
        }
        if (ucustaki) {
            siradakiZorla = ucustaki.then(() => {
                siradakiZorla = null;
                return calistir();
            });
            return siradakiZorla;
        }
        return calistir();
    }
    if (ucustaki || siradakiZorla || Date.now() - sonTazelemeZamani < MIN_ARALIK_MS) {
        return Promise.resolve(false);
    }
    return calistir();
}

function calistir(): Promise<boolean> {
    sonTazelemeZamani = Date.now();
    const istek: Promise<boolean> = benCek().then((sonuc) => {
        if (ucustaki === istek) {
            ucustaki = null;
        }
        return sonuc;
    });
    ucustaki = istek;
    return istek;
}

async function benCek(): Promise<boolean> {
    const no = benIstegiBaslat();
    try {
        // Axios yanıt kesicisi response.data döndürür; /ben doğrudan kullanıcı nesnesidir.
        const kullanici = await app.$http.get("/api/v1/ben");
        // Sonra başlamış bir /ben (özellik tazelemesi) zaten yazdıysa elimizdeki daha eski: yazılmaz, kullanıcı güncel.
        if (benYanitiYazilsinMi(no)) {
            app.$store.commit("setUser", kullanici);
        }
        return true;
    } catch (e) {
        // Hata global kesicide zaten gösterilir; tazeleme sessizce başarısız olur.
        return false;
    }
}
